import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import {
  API_URL,
  IPushProvisionEmailVerificationRequest,
  IVerificationCodeValidationResponseDto,
} from '@/dtos';

const useEmailValidationQuery = () => {
  const {
    mutateAsync: handleVerifyCode,
    isLoading: isVerificationCodeLoading,
    isError: isVerificationCodeError,
  } = useMutation((body: Partial<IPushProvisionEmailVerificationRequest>) =>
    api.patch<IVerificationCodeValidationResponseDto>(API_URL.PUSH_PROVISION_EMAIL_VALIDATION, body)
  );

  return {
    handleVerifyCode,
    isLoading: isVerificationCodeLoading,
    isError: isVerificationCodeError,
  };
};

export default useEmailValidationQuery;
